export const REPORT_REQUEST = "REPORT_REQUEST";
export const REPORT_SUCCESS = "REPORT_SUCCESS";
export const REPORT_ERROR = "REPORT_ERROR";
export const REPORT_PARAMETERS = "REPORT_PARAMETERS";
export const REPORT_RESTAPI = "REPORT_RESTAPI";



// WEBPACK FOOTER //
// ./src/store/actions/report.js